export default __webpack_public_path__ + "static/media/q25_03.4ef39b8d.png";